import React from 'react';

import ChangedField from '@components/common/ChangedField/ChangedField';

import { IAssetFile } from '@interfaces/assets/asset';

import FileChanged from './FileChanged';

import styles from './FilesListChanged.module.scss';

type TChangedFile = {
	current: IAssetFile | null;
	previous: IAssetFile | null;
	isChanged: boolean;
};

interface IFilesListProps {
	files: TChangedFile[];
	maxWidth?: number;
}

const FilesList = ({ files, maxWidth = 170 }: IFilesListProps) =>
	<div className={styles.filesListContainer}>
		{!!files.length &&
			files.map((file, key) => {
				const value = file.current || file.previous;

				const fileItem = <FileChanged
					file={value}
					maxWidth={maxWidth}
				/>;

				return (
					<ChangedField
						key={`file-${key}-${value?.name}}`}
						current={file.current ? fileItem : null}
						isChanged={file.isChanged}
						previous={file.previous ? fileItem : null}
					/>
				);
			})}
	</div>;

export default FilesList;
